/* eslint-disable no-unused-vars */
import React from "react";
import { MdSettings } from "react-icons/md";
import { useHistory } from "react-router-dom";
import Board from "../../../../components/Config/Board";
import {
  plugInMenu,
  securityMenu,
  settingsMenu,
} from "../../../../utils/helpers/configs";
import { mergeTo } from "../../../../utils/helpers/logicHelper";

function Body({ domainBrand, profile }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const history = useHistory();
  // get the current module(s)
  const userModules = profile?.userData?.modules;
  const objectMap = (mapper) => {
    const x = userModules?.map((type) => {
      let temp = [];
      let i = mapper[type];
      temp = i !== undefined ? [...i] : [];
      return temp;
    });

    return x;
  };

  // check for objectMap array length, collect inside a single array and check for duplicates
  const settingsMap = mergeTo(objectMap(settingsMenu));
  // const pluginMap = mergeTo(objectMap(plugInMenu));
  const pluginMap = [
    {
      id: 1,
      to: "/plugins/payout-api/add-payout-api",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Add Pay-out API",
      lingualText: "WO_ADD_NEW_PLUGI_1498103904",
      visibleTo: [
        "DIGITAL_BANKING",
        "PAY_OUT_PARTNER",
        "ELECTRONIC_MONEY_SERVICES",
        "WALLET_ACCOUNT_MANAGEMENT",
        "REMITTANCE",
      ],
    },
    {
      id: 2,
      to: "/plugins/payout-api/add-new-partner",
      icon: "fa fa-file-invoice",
      iconSvg: <MdSettings color={"#6259CA"} fontSize={24} fill={"#6259CA"} />,
      text: "Connector",
      lingualText: "WO_CONNECTO_-2049653177",
      visibleTo: ["REMITTANCE"],
    },
  ];
  const securityMap = mergeTo(objectMap(securityMenu));

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title text-capitalize">
              {dictionary &&
              dictionary["WO_CONFIGURATION_-464461515"] !== undefined
                ? dictionary["WO_CONFIGURATION_-464461515"]
                : "Configurations"}
            </h1>
          </div>
          <div className="ms-auto pageheader-btn" />
        </div>

        <div className="row">
          {settingsMap?.length > 0 && (
            <Board
              dictionary={dictionary}
              data={settingsMap}
              title={"Settings"}
              lingualText={"m_general3"}
            />
          )}

          {/* {pluginMap?.length > 0 && (
            <Board
              dictionary={dictionary}
              data={pluginMap}
              title={"Plugins/API"}
              lingualText={"WO_PLUGINSAP_-161147171"}
            />
          )} */}

          {pluginMap?.length > 0 && (
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 height-100">
              <div className="row">
                <div className="col-xl-12 col-md-12">
                  <div className="card overflow-hidden">
                    <div className="card-header bg-primary text-white">
                      {" "}
                      {dictionary &&
                      dictionary["WO_PLUGINSAP_-161147171"] !== undefined
                        ? dictionary["WO_PLUGINSAP_-161147171"]
                        : "Plugins/API"}
                    </div>
                    <div className="row card-dashboard-center">
                      <div className="col-xl-12 col-md-12">
                        <div className="card-body pb-0 pt-4">
                          <div className={`row w-100 card-dashboard-center`}>
                            <div
                              className={`col-xl-2 col-lg-3 col-md-4 col-sm-4 col-xs-6`}
                              // key={type.id + index}
                            >
                              <div
                                onClick={() =>
                                  history.push(
                                    `/plugins/payout-api/add-payout-api`
                                  )
                                }
                                className={`card pointer shadow }`}
                              >
                                <div className="card-body text-center">
                                  <MdSettings
                                    color={"#6259CA"}
                                    fontSize={24}
                                    fill={"#6259CA"}
                                  />
                                  <h6 className="mt-2 fs-12 mb-2">
                                    {dictionary &&
                                    dictionary[
                                      "WO_ADD_NEW_PLUGI_1498103904"
                                    ] !== undefined
                                      ? dictionary[
                                          "WO_ADD_NEW_PLUGI_1498103904"
                                        ]
                                      : "Add Pay-out API"}
                                  </h6>
                                </div>
                              </div>
                            </div>

                            {userModules?.includes("DIGITAL_BANKING") ||
                            userModules?.includes(
                              "ELECTRONIC_MONEY_SERVICES"
                            ) ||
                            userModules?.includes(
                              "WALLET_ACCOUNT_MANAGEMENT"
                            ) ? (
                              <div
                                className={`col-xl-2 col-lg-3 col-md-4 col-sm-4 col-xs-6`}
                              >
                                <div
                                  onClick={() =>
                                    history.push(
                                      `/plugins/payout-api/add-new-partner`
                                    )
                                  }
                                  className={`card pointer shadow }`}
                                >
                                  <div className="card-body text-center">
                                    <MdSettings
                                      color={"#6259CA"}
                                      fontSize={24}
                                      fill={"#6259CA"}
                                    />
                                    <h6 className="mt-2 fs-12 mb-2">
                                      {dictionary &&
                                      dictionary["WO_CONNECTO_-2049653177"] !==
                                        undefined
                                        ? dictionary["WO_CONNECTO_-2049653177"]
                                        : "Connector"}
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {securityMap?.length > 0 && (
            <Board
              dictionary={dictionary}
              data={securityMap}
              title={"Security"}
              lingualText={"m_security"}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Body;
